const mensajes = {
    // CampoCodigoDocumentoBase
    'DocumentoBuscador.CampoCodigoDocumentoBase.Nombre': 'Código documento base',
};

export default mensajes;
